import React from "react";
import { Link } from "react-router-dom";
import { MEDIA } from "@/lib/media";
import { Paw } from "@/components/decor";

const messages = [
  "🐾 Welcome to The Happy Bulldog Co.™ — Home of Chewie & Solo!",
  "New Adventures. New Mischief. Lots of Bulldog Happiness.",
  "Books • Bulldogs • Adventures • Happiness",
];

export default function AnnouncementBar() {
  const strip = [...messages, ...messages];
  return (
    <div className="w-full bg-[#FFD93D] text-[#19324A] overflow-hidden hidden sm:block" data-testid="announcement-bar">
      <div className="flex whitespace-nowrap hb-marquee py-1.5">
        {strip.map((m, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-2 text-xs sm:text-sm font-semibold font-display">
            <Paw className="w-4 h-4 text-[#FF6B9D]" /> {m}
          </span>
        ))}
      </div>
    </div>
  );
}
